import React from 'react';
import useImagePreload from 'rpf/react/hooks/useImagePreload';
import getPreoloadImgs from './utils';
import PageWrap from 'components/PageWrap';
import { Logo, Progress, ProgressBar, Text, LoadingSafeArea } from './Styles';

const { imgs } = getPreoloadImgs();

const Loading = ({ startLoad, onFinish }) => {
  const { loaded, total } = useImagePreload({
    imgs,
    startLoad,
    onFinish: () => {
      onFinish();
    },
    onError: err => console.log('preoload error', err)
  });

  return (
    <PageWrap>
      <LoadingSafeArea>
        <Logo></Logo>
        <Progress>
          <ProgressBar
            style={{
              width: `${Math.round(loaded / total) * 100}%`
            }}
          ></ProgressBar>
        </Progress>
        <Text>
          <span>loading</span>
        </Text>
      </LoadingSafeArea>
    </PageWrap>
  );
};

export default Loading;
